import { render, staticRenderFns } from "./ProfileInactive.vue?vue&type=template&id=3f3b14db&"
import script from "./ProfileInactive.vue?vue&type=script&lang=js&"
export * from "./ProfileInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports